export default __webpack_public_path__ + "static/media/manhattan-mover-1.ef163b15.svg";